
import { Component, Vue, Watch } from "vue-property-decorator";
import FormBase from "@/lib/view-base/formbase";
import { CreateProductCategoryDto, ProductCategoryService } from "@/api/service-proxies";
import SelectTree from "@/components/SelectTree/SelectTree.vue";

@Component({
    name: "CreateProductcategory",
    components: {
        SelectTree,
    },
})
export default class CreateProduct extends FormBase {
    productcategory: CreateProductCategoryDto = new CreateProductCategoryDto({isShow:true});
    productCategoryService: ProductCategoryService = new ProductCategoryService();
    schoolType = [];
    rules: object = {
        name: [{ required: true, message: "请输入标题名称", trigger: "blur" }],
        subtitle: [
            { required: true, message: "请输入副标题描述", trigger: "blur" },
        ]

    };

    options= [{
          value: '1',
          label: '单位(件)'
        }, {
          value: '2',
          label: '单位(人)'
        }]

    mounted() {

    }


    created() { }


    async submitExecute(): Promise<void> {
        this.productcategory.isShow=true;
        await this.productCategoryService.create(this.productcategory);
    }



}
